export const SectionsBlock = ({ sections }) => (
  <section className="section-padding bg-white" data-testid="sections-block">
    <div className="container-custom max-w-3xl">
      <div className="space-y-8">
        {sections.map((s) => (
          <div key={s.h2}>
            <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-3">{s.h2}</h2>
            <p className="text-slate-700 leading-relaxed">{s.content}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
